<template>
	<div class="raddar-pdp-old">
		<h2 class="header">
			<span class="pdpTitle">{{ content.pdpTitle }}</span>
			<button :aria-label="content.pdpClose" class="close-btn" tabindex="0" @click="closePdp"
			        @keydown.esc="closePdp">
				<img src="/images/icon-close-white.svg" alt="Close" />
			</button>
		</h2>

		<div ref="toastContent" class="content">
			<div :class="`content-container ${flyerOrientation}`">
				<div class="handle-border">
					<div class="pdpContainer">

						<!-- <template>
								 <h2 v-if="currentProduct.productFr !== null" tabindex="0">{{ currentProduct.productFr }}</h2>
								 <h2 v-if="currentProduct.productEn && currentProduct.productFr"> | </h2>
								 <h2 v-if="currentProduct.productEn !== null"> {{ currentProduct.productEn }} </h2>
								</template> -->
						<div class="productImageContainer">
							<image-magnifier 
								:image-src="product.productImage" 
								:alt-text="product.productEn || product.productFr || 'Product image'"
							/>
						</div>
						<div class="savings" v-if="product.savingsEn">
							<span>
								{{ product.savingsPrefix }}
								{{ product.savingsEn }}
								{{ product.savingsSuffix }}</span>
						</div>
						<div v-if="language == 'en'" class="price" tabindex="0">
							<h2>
								<span v-if="product.priceQuantity">{{ product.priceQuantity }}/
								</span>

								<span v-if="product.salePricePrefixEn"> {{ product.salePricePrefixEn }}
								</span>
								<!-- <span> ${{ parseFloat(currentProduct.salePrice).toFixed(2) }}</span> -->
								<span v-if="product.salePrice == null ||
									product.salePrice === '' ||
									product.salePrice === '$NaN' ||
									product.salePrice === 'NaN$'
									"></span>
								<span v-else-if="product.salePrice === '3.99 à 7.99'">
									$3.99 à $7.99</span>
								<span v-else-if="isNaN(product.salePrice)">
									{{ product.salePrice }}
								</span>

								<span v-else-if="product.salePrice.includes('à')">
									${{ product.salePrice }}
								</span>

								<span v-else>
									${{ parseFloat(product.salePrice).toFixed(2) }}</span>
								<!-- <span v-else> ${{currentProduct.salePrice}}</span> -->

								<span v-if="product.promoUnitEn">
									{{ product.promoUnitEn }}
								</span>
								<span v-if="product.alternatePrice" class="alternatePrice">{{
										product.alternatePrice
									}}</span>
							</h2>
						</div>

						<div v-else class="price" tabindex="0">
							<h2>
								<span v-if="product.priceQuantity">{{ product.priceQuantity }}/
								</span>
								<!-- <span v-html="showPriceFr(currentProduct.salePrice)"> $ </span> -->

								<span v-if="product.salePricePrefixFr"> {{ product.salePricePrefixFr }}
								</span>
								<span v-if="product.salePrice == null ||
									product.salePrice === '' ||
									product.salePrice === '$NaN' ||
									product.salePrice === 'NaN$'
									"></span>
								<span v-else-if="product.salePrice === '3.99 à 7.99'">
									3,99$ à 7,99$</span>
								<span v-else-if="isNaN(product.salePriceFr)">
									{{ product.salePriceFr }}
								</span>
								<span v-else-if="product.salePrice.includes('à')">
									{{ product.salePrice.replaceAll(".", ",") }}$</span>
								<span v-else>
									{{
										parseFloat(product.salePrice)
												.toFixed(2)
												.replace(".", ",")
									}}$</span>
								<span v-if="product.promoUnitFr">
									{{ product.promoUnitFr }}
								</span>
								<span v-if="product.alternatePriceFr" class="alternatePrice">{{
										product.alternatePriceFr
									}}</span>
							</h2>
						</div>

            <div v-if="showTierEachPrice" class="daysOnly">
              {{ tierEachPrice }}
            </div>

						<div v-if="product.contents || product.bodyFr || product.bodyEn ||
						    product.productFr || product.productEn"
						     class="detail">
							<div class="detail-header">
								<h2 v-if="language == 'en' && product.productEn !== null" tabindex="0"> {{ product.productEn }} </h2>
								<!-- <h2 v-if="currentProduct.productEn && currentProduct.productFr"> | </h2> -->
								<h2 v-else-if="language == 'fr' && product.productFr !== null" tabindex="0">{{ product.productFr }}</h2>


							</div>
							<!-- <span>{{ content.pdpDetails }}</span> -->
							<p v-if="language == 'en'" class="detail-content" tabindex="0">
								{{ getContents || product.bodyEn || product.bodyFr }}
							</p>
							<p v-if="language == 'fr'" class="detail-content" tabindex="0">
								{{ getContents || product.bodyFr || product.bodyEn }}
							</p>
							<span v-if="product.sku" class="product-sku">#{{ product.sku }}</span>
						</div>
						<!-- <div class="validity">
							<span><strong>{{ content.pdpValidFrom }}</strong></span>
							<div class="date" v-html="flyerDate(currentProduct.validFrom, currentProduct.validTo)"></div>
						</div> -->
						<!-- <p class="disclaimer-content">{{ content.disclaimer }}</p> -->



					</div>
					<div class="addtoList-container">
						<!-- <button v-if="checkProductInSL(currentProduct)" class="pdpAddToList removeFromList" tabindex="0"
						@click="handleRemoveFromList(currentProduct)">
						<span> {{ content.pdpRemoveFromList }} </span>
					</button> -->

						<button class="pdpAddToList" tabindex="0" v-tooltip="{content: `Add to Shopping List`, placement: 'bottom'}"
						        @click=handleAddToList(product)>
							<img src="/icons/add-to-shopping-list.svg">
						</button>
						<!-- <button class="shareDeal" tabindex="0" v-tooltip="{content: `Share This Deal`, placement: 'bottom'}"
									@click=handleShareDeal(currentProduct)>
						<img src="/icons/share-icon.svg" >
					</button> -->
						<!-- <button class="goToWebsite" tabindex="0"  v-tooltip="{content: `Go To Website`,  placement:'bottom'}"
									@click=handleWebsiteLink(currentProduct)>
						<img src="/icons/globe-icon.svg">
					</button> -->
						<a v-if="product.url !== null" :href="goToWebsite" class="goToWebsite" v-tooltip="{content: `Go To Website`,  placement:'bottom'}" target="_blank">
							<img src="/icons/globe-icon.svg">
						</a>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import featureMixin from "@/mixins/featureMixin";
import AppConfig from "@/classes/AppConfig";
import pdpProductMixin from "@/features/pdp/PdpProductMixin";

export default {
	name:"RaddarPDPOld",
	directives: {
		ClickOutside,
	},
	mixins: [featureMixin, pdpProductMixin],

	data() {
		return {
			toastContent: null,
			ready: false,
			featurePath: 'pdp',
			featureEvents: ['productRegionClick']
		};
	},
	mounted() {
		// console.log(this.$refs.pdpPopup);
		/*if(this.enabled){
				const pdpFocus = this.$refs.pdpPopup;
				pdpFocus.focus();
			}*/

	},
	computed: {
		...mapGetters(["content", "language"]),
		...mapGetters("screen", ["flyerOrientation"]),
		...mapGetters("landingPage", ["currentFlyer"]),
		...mapState("shoppingList", ["shoppingList"]),
		...mapGetters("pdp", { pdpEnabled: "enabled" }),
		...mapState("pdp", { showPdp: "isVisible" }),
		...mapGetters('shoppingList', { listEnabled: 'enabled' }),
		getContents() {
			return this.product?.contents
		},
		columnView() {
			return this.flyerOrientation === "vertical";
		},

		enabled() {
			return this.pdpEnabled && this.config.mode === 'internal';
		},
		isAdonis() {
			if (AppConfig.AppConf?.title.toLowerCase().includes("adonis".toLowerCase())) {
				return true
			}
			else return false
		},
		goToWebsite() {
			let url = this.product.url
			if (!url.startsWith("https://") && !url.startsWith("https://")) {
				url = "https://" + url;
			}
			return url
		},

	},

	methods: {
		...mapActions(["setPdpDisplay", "setCurrentProduct"]),
		...mapActions("shoppingList", ["setAddToList", "setRemoveFromList"]),
		...mapActions("pdp", ["close", "open"]),

		onFeatureEvent(event, data) {
			if (this.config.enabled) {
				// console.log('PDP Event:', data.product)
				if (this.config.mode === 'internal' && data.actionType !== 'url' && data.sku !== 'url' && !data.isVideo) {
					this.open(data.product);
				}
			}
		},

		closePdp() {
			if (this.ready) {
				this.close();
			}
		},
		handleAddToList(product) {
			// console.log("Handle add to list", product)

			const additionalItemFlag = false;
			const messageData = {
				type: 'ADD_TO_SHOPPING_LIST',
				product: JSON.stringify(product),
				additionalItemFlag: additionalItemFlag,
			}
			window.parent.postMessage(window.JSON.stringify(messageData),'*')
			this.setAddToList({ product, additionalItemFlag });
		},

		handleRemoveFromList(product) {
			this.setRemoveFromList(product);
		},

		handleShareDeal(product) {
			const dealData = {
				type: 'SHARE_DEAL',
				product: JSON.stringify(product),
			}
			window.parent.postMessage(window.JSON.stringify(dealData),'*')
		},
		handleWebsiteLink(product) {
			const linkData = {
				type: 'OPEN_BANNER_WEBSITE',
				product: JSON.stringify(product),
			}
			window.parent.postMessage(window.JSON.stringify(linkData),'*')
			const urlSegments = window.location.pathname.split('/')[1];
			if (urlSegments === `bdcc09c8-2e5c-45d5-89e9-76a67f19c26c`) {
				window.location.href = `https://www1.shoppersdrugmart.ca/en/flyer`;
			}

		},
		checkProductInSL(product) {
			let item = this.shoppingList.filter(function (e) {
				return e.sku == product.sku;
			});
			if (item.length > 0) return true;
			else return false;
		},
		showPriceFr(price) {
			if (!price) return;

			return (
				parseFloat(price)
					.toFixed(2)
					.replace(".", ",") + " $"
			); //adds zeros
			// return(frPrice+" $")
			// console.log('price is' + (price.toFixed(2)))
			// return((price).replace(".",",")+" $")
		},
		showPriceEn(price) {
			if (!price) return;
			// let enPrice = price.replace(",",".")
			else if (price.includes("$")) {
				let priceWith$ = price.replace("$", "");
				if (priceWith$.includes(",")) {
					let enPrice = priceWith$.replaceAll(",", ".");
					return "$" + enPrice;
				}
				return "$" + priceWith$;
			}
			return "$" + price.replace(",", ".");
		},
		flyerDate(validFrom, validTo) {
			const start = validFrom ? moment.utc(validFrom) : moment.utc(this.currentFlyer.startDate);
			const endDate = validFrom ? moment.utc(validTo) : moment.utc(this.currentFlyer.endDate);
			if (this.language === "en") {
				if (this.product.sku === "10024392") {
					// console.log("roses");
					return `${moment("2022-02-12").format("MMMM D, YYYY")} <span style="color: #000">to</span> ${moment("2022-02-14").format("MMMM D,YYYY")}`;
				} else
					return `${start.locale('en').format("MMMM D, YYYY")} <span style="color: #000">to</span> ${endDate.locale('en').format("MMMM D, YYYY")}`;
			} else {
				if (this.product.sku === "10024392")
					return `${moment("2022-02-12").format("D MMMM, YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} <span style="color: #000">jusqu'au</span> ${moment("2022-02-14").format("D MMMM, YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')}`;
				else
					return `${start.format("D MMMM, YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} <span style="color: #000">jusqu'au</span> ${endDate.format("D MMMM, YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>'
					)}`;
			}
		}
	},

	watch: {
		showPdp(val) {
			if (val) {
				setTimeout(() => {
					this.ready = true;
					const pdpFocus = this.$refs.pdpPopup;
					pdpFocus.focus();
				}, 100);
			}
			this.ready = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.mobile {
  display: none !important;
  flex-flow: column;
  row-gap: 2em;
  padding: 1.5em;

  .description {
	display: flex;
	flex-flow: row;
	text-align: left;
	align-items: flex-end;

	> :first-child {
	  width: calc(55px + 1em);
	}

	.mobile-content {
	  flex-basis: 100%;
	}
  }
}

.modal-wpr {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 20;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-flow: column;

  .modal {
	//background-color: var(--secondary-color);
	background-color: #fff;
	/*margin-top: 75px;*/
	border: 1px solid #bbbbbb;
	/* overflow: auto;*/
	max-height: calc(100% - 1em);
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	display: flex;
	max-width: calc(100% - 4em);

	.header {
	  background-color: #261342;
	  color: var(--primary-text-color);
	  display: flex;
	  justify-content: space-between;
	  padding: 10px;

	  h2 {
		font-size: 18px;
		text-transform: uppercase;
		font-weight: 400;
	  }

	  .close-btn {
		cursor: pointer;

		&:hover {
		  background: none;
		  filter: unset;
		}
	  }
	}

	.subtitle {
	  padding-top: 6px;
	  font-size: 12px;
	}

	.content {
	  padding: 8px;
	  background-color: #fff;
	  color: #545454;
	  position: relative;
	  flex: 1 0 auto;
	  // overflow: auto;
	  // margin:0px 10px 10px 10px;
	  margin: 10px 10px 17px;
	  min-height: 250px;
	  max-height: calc(100% - 4em);


	  /*.scroll-container{
		position: absolute;
		top:0px;
		bottom:0px;
		left:0px;
		right:0px;
	}*/
	  .content-container {
		text-align: left;
		//width:300px;
	  }

	  .f-half {
		display: flex;
		column-gap: 1em;

		flex-direction: column;

		>div {
		  flex-basis: 100%;
		  display: flex;
		  flex-flow: column;
		}
	  }

	  .content-container {
		// width: 350px;
	  }

	  .feature {
		background: #eee;
		margin: 12px 0;
		display: flex;
		justify-content: center;
		flex: 1;

		.description {
		  display: flex;
		  font-size: 14px;
		  padding: 15px 0;

		  .button-preview {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 0 20px;

			h4 {
			  text-transform: uppercase;
			  padding-top: 16px;
			  white-space: nowrap;
			}

			.subtitle {
			  text-align: center;
			}
		  }
		}
	  }
	}
  }
}

.pdpTitle {
  font-size: 18px;
  font-weight: bold;
  margin-top: 6px;
}

.pdpContainer {
  //margin-left: 10px;
  max-width: calc(100vw - 5em);
  border: 1px solid #D3D3D3;
  padding: 10px;

  h2 {
	font-size: 18px;
	line-height: 1.1em;

	span {
	  font-size: 24px;
	  margin-top: 6px;

	}
  }

  .productImageContainer {
	padding: 5px 0;
	margin-bottom: 10px;
	border: 1px solid #D3D3D3;
	display: flex;
	justify-content: center;
  }

  .productImage {
	// max-height: 60%;
	// max-width: 60%;
	max-height: 200px;
	max-width: 90%;
	width: auto;
	height: auto;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
  }

  .price {
	display: flex;
	//color: #ee3124;
	color: #E95B5B;
	font-weight: 900;
  }

  span.alternatePrice {
	display: inline-block;
  }

  .alternatePrice {
	color: #000;
	font-size: 13px;
	font-weight: normal;
	margin-left: 5px;
  }

  .savings {
	text-transform: uppercase;
	color: #000;
	font-size: 17px;
	font-weight: 900;

	span {
	  display: block;
	  margin-bottom: 7px;
	}
  }

  .detail {
	font-size: 15px;
	margin-top: 10px;
	font-weight: 900;

	.detail-header{
	  display: flex;
	  h2 {
		margin-right: 5px;
	  }
	}

	.detail-content {
	  font-size: 14px;
	  font-weight: normal;
	  margin: 5px 0 8px;

	}
	.product-sku {
	  font-size: 12px;
	}
  }

  .disclaimer-content {
	font-size: 9px;
	font-weight: normal;
	margin-top: 10px;
	font-style: italic;
  }

  & .validity {
	font-size: 13px;
	margin-top: 10px;

	.date {
	  color: #E95B5B;
	  font-weight: bold;
	}

  }
  .daysOnly {
    margin-top: 10px;
    font-size: 1.1em;
    font-weight: 900;
  }
}

button, a.goToWebsite {
  background: transparent;
  // border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  border-radius: 4px;
  border: none;
}

button.button {
  background: #fff;
  border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 16px;
}

button.button:hover {
  background: #eee;
  color: #000;
}

.btn {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 4px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  color: #333;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  cursor: auto;
  pointer-events: none;
}

.addtoList-container {
  display: flex;
  margin: 15px 4px 0;
  button, a.goToWebsite {
	padding: 5px;
	min-height: 34px;
	min-width: 34px;
	transition: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: #D3D3D3;
	border-radius: 50%;
	margin-right: 10px;
	img {
	  width: 1.2rem;
	  height: 1.2rem;

	}
  }
  .goToWebsite {
	margin-left: auto;
	margin-right: 0;
  }
}

.pdpAddToList {
  // display: flex;
  // flex-grow: 0.7;
  cursor: pointer;
  // width: 100%;
  // border-radius: 5px;
  // margin-top:15px;
  // margin-bottom:15px;
  // margin-right: 10px;
  // margin: 15px 0px 10px 0px;
  // background-color: var(--tertiary-color);
  color: #fff;
  padding: 8px;
  justify-content: center;
  // max-width: calc(100vw - 7em);
  font-weight: normal;

  &.removeFromList {
	background-color: #EE3124;
  }
}

/* width */
::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  //background: #f1f1f1;
  display: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btn.page {
  width: 100%;
  height: 28px;
  justify-content: flex-start;
  padding-left: 3%;
  margin-bottom: 8px;

  &+.subtitle {
	text-align: left !important;
  }
}

.page-num {
  background-color: var(--primary-color);
  color: var(--primary-text-color);
  border-radius: 4px;
  font-size: 12px;
  padding: 7px;
}

/*@media only screen and (max-width: 1024px){
    .modal-wpr .modal{
      .content {
        .f-half {
          flex-direction: column !important;
        }
        .content-container{
          width: 925px;
        }
      }
    }
  }*/

.navigation {
  .description {
	flex-basis: 50%;
	justify-content: center;
  }
}

@media only screen and (max-height: 850px) and (min-width: 1024px) {
  .modal-wpr .modal {
	.content {
	  .f-half {
		flex-direction: row !important;
	  }

	  .content-container {
		width: 300px;
	  }
	}
  }
}

@media only screen and (max-width: 700px) and (min-width: 558px) {
  .modal-wpr .modal {
	.content {
	  .content-container {
		// width: 575px;
	  }
	}
  }
}

@media only screen and (max-width: 700px) {
  .modal-wpr .modal {
	.content {
	  .content-container {

		//width: 300px;
		.productImage {
		  // max-height: 50%;
		  // max-width: 50%;
		  max-height: 180px;
		  max-width: 85px;
		}
	  }
	}
  }
}

/* Vertical View Specific */
@media (min-width: 1200px) {
  .modal-wpr .modal.vertical .content .feature.navigation {
	/*.description {
		padding-top: 10px;
		padding-left: 100px;
		padding-bottom: 70px;
		position: relative;
	}*/

	/*.btn.page {
		transform: rotate(90deg);
		width: 146px;
		position: absolute;
		left: 0;
		bottom: 38%;
	}*/

	h4,
	.subtitle {
	  text-align: left;
	  width: 100%;
	}

	.subtitle+.subtitle {
	  margin-top: 1em;
	}
  }

  .content-container {
	width: 300px;
  }
}

@media (max-width: 850px) {
  /*.modal-wpr {
	top: 125px;
}*/
}

@media (min-width: 850px) and (max-width: 1023px) {
  /*.modal-wpr {
	top: 125px;
}*/
}

/* Mobile */
@media (min-width: 1024px) and (max-width: 1200px) {

  /*.modal-wpr {
	top: 65px;
}*/
  .walkthrough {
	display: none;
  }
}

@media (max-width: 1200px) {
  .mobile {
	display: flex !important;
  }

  .desktop {
	display: none !important;
  }

  .modal-wpr .modal {
	/* margin-top: 140px;
	width: 90% !important;*/
	width: 338px;

	.content {
	  .f-half {
		/*flex-direction: row !important;*/
	  }

	  .content-container {
		// width: 400px;
	  }
	}

	.header {
	  padding-bottom: 4px;

	  h2 {
		font-size: 14px;
	  }
	}
  }

  .heading {
	display: none;
  }

  .modal-wpr .modal .content .feature {
	display: block;
	background: none;
	padding: 0 6%;

	.description {
	  padding: 0;
	  margin-bottom: 20px;
	  height: 50px;
	}

	.button-preview {
	  display: block;
	  position: relative;
	  padding-left: 60px;
	  width: 100%;

	  h4 {
		padding: 0;
	  }

	  .subtitle {
		text-align: left;
	  }

	  .btn {
		position: absolute;
		top: 0;
		left: 0;
	  }
	}
  }

  .subtitle.mobile {
	text-align: center;
	margin-bottom: 20px;
  }
}
</style>
